import { Link } from "react-router-dom";
function About() {
    return (
        <div>

            <div className="about-banner-container">
                <div className="about-banner">
                    <h1>Innovative Solutions <br />For The Future</h1>
                    <p>Innovate, Integrate, Inspire: Your Software Solutions Partner.</p>
                    <Link to="/contact">
                        <button className="btn">Let's Talk!</button>
                    </Link>
                </div>
            </div>

            <div className="about01">
                <p>At <strong>FutApp</strong>, we are a dynamic and innovative software development company committed to transforming ideas into reality. Our journey began in 2023, when a group of passionate tech enthusiasts decided to combine their expertise and vision to create solutions that drive digital transformation. From our humble beginnings, we have grown into a dedicated team of skilled developers, designers, and project managers who work tirelessly to deliver top-notch software solutions. Our mission is to empower businesses by providing them with cutting-edge technology, tailored to meet their unique needs. We aim to be a trusted partner in our clients' success, helping them achieve their goals and stay ahead in an ever-evolving digital landscape.</p>

                <div className="mission">
                    <div>
                        <img src="media/About/Mission.png" alt="Mission" />
                    </div>
                    <p>
                        At FutApp, our mission is to deliver innovative and tailored software solutions that empower businesses to achieve their goals. We are dedicated to fostering growth, efficiency, and excellence by leveraging cutting-edge technology and unparalleled expertise. Our commitment to customer satisfaction drives us to continually evolve and adapt, ensuring we provide the highest quality services and support to our clients.
                    </p>
                </div>

                <div className="mission vision">
                    <p>
                        Our vision is to be a global leader in software development, recognized for our ability to transform ideas into impactful solutions that drive digital transformation. We aspire to create a future where technology seamlessly integrates into every aspect of business, enabling organizations to thrive in an ever-changing world. By fostering a culture of innovation, collaboration, and excellence, we aim to set new standards in the industry and make a lasting positive impact on the businesses we serve.
                    </p>
                    <div>
                        <img src="media/About/Vision.png" alt="Vision" />
                    </div>
                </div>

                <div className="values">
                    <h1>Core Values</h1>

                    <div className="value">
                        <p>
                            <span>Innovation: </span>
                            We are committed to fostering a culture of creativity and forward-thinking, constantly pushing the boundaries of technology to deliver cutting-edge solutions.
                        </p>
                    </div>
                    <div className="value">
                        <p>
                            <span>Excellence: </span>
                            We strive for the highest standards in everything we do, ensuring that our products and services consistently exceed expectations.
                        </p>
                    </div>
                    <div className="value">
                        <p>
                            <span>Customer-Centricity: </span>
                            Our clients are at the heart of our business. We prioritize their needs and work collaboratively to deliver tailored solutions that drive their success
                        </p>
                    </div>
                    <div className="value">
                        <p>
                            <span>Integrity: </span>
                            We conduct our business with honesty, transparency, and ethical principles, building trust with our clients, partners, and team members.
                        </p>
                    </div>
                    <div className="value">
                        <p>
                            <span>Collaboration: </span>
                            We believe in the power of teamwork and open communication. By working together, we achieve greater results and foster a positive and supportive work environment.
                        </p>
                    </div>
                    <div className="value">
                        <p>
                            <span>Continuous Improvement: </span>
                            We are dedicated to learning and growth, continually enhancing our skills, processes, and technologies to stay ahead in the industry.
                        </p>
                    </div>
                    <div className="value">
                        <p>
                            <span>Adaptability: </span>
                            In a rapidly evolving digital landscape, we embrace change and remain agile, ready to pivot and innovate as needed to meet the demands of the future.
                        </p>
                    </div>
                    <div className="value">
                        <p>
                            <span>Empowerment: </span>
                            We empower our team members to take initiative, make informed decisions, and contribute to the success of the company and our clients.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About;